import * as React from 'react';
import * as styles from './BuyResultModal.css';
import { ModalWindow } from '@cian/ui-kit';
import { BuyResultModalContent } from './components/BuyResultModalContent';
import { clsx } from 'clsx';

interface IProps {
  isMobile: boolean;
  onClose(): void;
}

export const BuyResultModal = (props: IProps) => {
  const { isMobile, onClose } = props;

  return (
    <ModalWindow open onClose={onClose}>
      <div className={clsx(styles['modal_content'], isMobile && styles['modal_content_mobile'])}>
        <BuyResultModalContent />
      </div>
    </ModalWindow>
  );
};
